import React from "react";
import cx from "classnames";
import {createUseStyles} from "react-jss";
import {BackButton} from "../question/BackButton";
import {NextButton} from "../question/NextButton";
import {Dots} from "../navigation/Dots";
import {useNavigation} from "../navigation/useNavigation";
import {useCurrentAnswer} from "../answer/useCurrentAnswer";

const useStyles = createUseStyles({
    steps: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "1200px",
        width: "90%",
        padding: "16px 0 28px",
        boxSizing: "border-box",
        flexShrink: 0,
        "&.hasButtons": {
            justifyContent: "space-between",
        },
    },
    buttonWrapper: {
        minWidth: "190px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        "&.left": {
            justifyContent: "flex-start",
        },
        "&.right": {
            justifyContent: "flex-end",
        },
        "@media (max-width: 600px)": {
            minWidth: "48px",
            width: "48px",
            height: "48px",
        },
    },
});

export const Steps = () => {
    const {questionIndex} = useNavigation();
    const {
        answerUniqueId
    } = useCurrentAnswer();

    const classes = useStyles();

    const isMobile = typeof window !== "undefined" && window.matchMedia
        ? window.matchMedia("(max-width: 600px)").matches
        : false;

    return (
        <div className={cx(classes.steps, { hasButtons: questionIndex > 0 || answerUniqueId })}>
            <div className={cx(classes.buttonWrapper, "left")}>
                <BackButton
                   isMobile={isMobile}
                />
            </div>
            <Dots />
            <div className={cx(classes.buttonWrapper, "right")}>
                <NextButton
                    isMobile={isMobile}
                />
            </div>
        </div>
    );
};
